module.exports = __webpack_public_path__ + "img/blue-dots.2eb5db0b.png";